// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"ArticlesListing_articleCard__BZfhX","buttonWrapper":"ArticlesListing_buttonWrapper__LMTbI","articlesWrapper":"ArticlesListing_articlesWrapper__6h5LU"};